export default function ({ $gtm, route }) {
  const gTag = 'GTM-TT4GHQX'
  $gtm.init(gTag)
}
